export const FilterIcon = ({
  width = 24,
  height = 24,
  stroke = "#000000",
  strokeWidth = 3,
}: {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7083 8.74752C16.6192 8.74736 17.5057 8.44317 18.236 7.88017C18.9664 7.31716 19.5017 6.52538 19.7623 5.62252H22.9583C23.2788 5.62252 23.5861 5.49083 23.8128 5.25641C24.0394 5.02199 24.1667 4.70404 24.1667 4.37252C24.1667 4.041 24.0394 3.72306 23.8128 3.48864C23.5861 3.25422 23.2788 3.12252 22.9583 3.12252H19.7623C19.5012 2.22012 18.9658 1.4289 18.2355 0.866363C17.5051 0.30383 16.6189 0 15.7083 0C14.7978 0 13.9115 0.30383 13.1812 0.866363C12.4509 1.4289 11.9154 2.22012 11.6544 3.12252H1.20833C0.887863 3.12252 0.580519 3.25422 0.353913 3.48864C0.127306 3.72306 0 4.041 0 4.37252C0 4.70404 0.127306 5.02199 0.353913 5.25641C0.580519 5.49083 0.887863 5.62252 1.20833 5.62252H11.6544C11.915 6.52538 12.4503 7.31716 13.1806 7.88017C13.911 8.44317 14.7975 8.74736 15.7083 8.74752ZM1.20833 15.6225C0.887863 15.6225 0.580519 15.7542 0.353913 15.9886C0.127306 16.2231 0 16.541 0 16.8725C0 17.204 0.127306 17.522 0.353913 17.7564C0.580519 17.9908 0.887863 18.1225 1.20833 18.1225H3.80021C4.06125 19.0249 4.5967 19.8162 5.32704 20.3787C6.05737 20.9412 6.94362 21.245 7.85417 21.245C8.76471 21.245 9.65096 20.9412 10.3813 20.3787C11.1116 19.8162 11.6471 19.0249 11.9081 18.1225H22.9583C23.2788 18.1225 23.5861 17.9908 23.8128 17.7564C24.0394 17.522 24.1667 17.204 24.1667 16.8725C24.1667 16.541 24.0394 16.2231 23.8128 15.9886C23.5861 15.7542 23.2788 15.6225 22.9583 15.6225H11.9081C11.6471 14.7201 11.1116 13.9289 10.3813 13.3664C9.65096 12.8038 8.76471 12.5 7.85417 12.5C6.94362 12.5 6.05737 12.8038 5.32704 13.3664C4.5967 13.9289 4.06125 14.7201 3.80021 15.6225H1.20833Z"
        fill={stroke}
      />
    </svg>
  );
};
